
import { Component, Vue } from 'vue-property-decorator'
import { CompanyDynamicClient, CompanyClient } from '@/api'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'
import moment from 'moment'
@Component({
  name: 'CompanyDynamicList',
  components: {
  },
  filters: {
    formatCompany(company:any) {
      return company ? company.name : '车队已被删除'
    },
    formatNumber(val:number) {
      return val.toFixed(2)
    }
  }
})
export default class extends BaseList {
  private companyClient = new CompanyClient()
  private companyList = []
  public constructor() {
    super()
    this.client = new CompanyDynamicClient()
    this.listQuery = {
      filter: {
        where: {
          description: { like: '' },
          createdAt: { begin: undefined, end: undefined },
          companyId: undefined
        },
        fields: {
          id: true,
          companyId: true,
          out: true,
          in: true,
          actual_in_amount: true,
          actual_out_amount: true,
          discount: true,
          balance: true,
          description: true,
          createdAt: true
        },
        include: [
          { relation: 'company' }
        ],
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc']
      }
    }
  }

  async created() {
    super.created()
    await this.getCompanyList()
  }

  private async getCompanyList() {
    this.companyList = await this.companyClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true
        },
        order: ['createdAt']
      }
    })
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    const and = []
    if (!_.isNil(t.filter.where.description) && !_.isEmpty(t.filter.where.description)) {
      and.push({ description: { like: `%${t.filter.where.description.like}%` } })
    }

    const createdAt = t.filter.where.createdAt
    if (createdAt.begin) {
      and.push({ createdAt: { gte: moment(createdAt.begin).utcOffset(480) } })
    }

    if (createdAt.end) {
      and.push({ createdAt: { lt: moment(createdAt.end).utcOffset(480) } })
    }

    if (_.isNumber(t.filter.where.companyId)) {
      and.push({ companyId: t.filter.where.companyId })
    }
    t.filter.where = { and }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected handleDownload() {
    this.listLoading = true
    const header = ['名称', '收入', '支出', '实际收入', '实际支出', '账户余额', '折扣', '备注', '时间']
    const filterVal = ['company.name', 'in', 'out', 'actual_in_amount', 'actual_out_amount', 'balance', 'discount', 'description', 'createdAt']
    const data = _.union([header], this.formatJson(filterVal, this.list))
    this.exportXlsx(data)
    this.listLoading = false
  }

  protected formatJson(filterVal :any, jsonData:any) {
    const data = jsonData.map((v:any) => filterVal.map((j:any) => {
      if (j === 'createdAt') {
        return this.parseTime(v[j])
      } else if (j === 'company.name') {
        return v['company']['name']
      } else {
        return v[j]
      }
    }))
    return data
  }
}
